var _defs, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVatViesStatementReport(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 198.425 198.425",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_0_517d1a40c5c0a8ac4898b89c98d977e2c6d8d93f25814fe91869087757785dfe",
    x1: 922.003,
    y1: 78.557,
    x2: 963.72,
    y2: 78.557,
    gradientTransform: "matrix(-1 0 0 1 1021.077 0)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "var(--icon-menu-gradient-start, #7a0399)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "var(--icon-menu-gradient-end, #b10372)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_517d1a40c5c0a8ac4898b89c98d977e2c6d8d93f25814fe91869087757785dfe",
    x1: 45.867,
    y1: 124.276,
    x2: 83.183,
    y2: 124.276,
    xlinkHref: "#SVGID_0_517d1a40c5c0a8ac4898b89c98d977e2c6d8d93f25814fe91869087757785dfe"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_517d1a40c5c0a8ac4898b89c98d977e2c6d8d93f25814fe91869087757785dfe",
    x1: 51.771,
    y1: 138.711,
    x2: 77.569,
    y2: 138.711,
    xlinkHref: "#SVGID_0_517d1a40c5c0a8ac4898b89c98d977e2c6d8d93f25814fe91869087757785dfe"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_517d1a40c5c0a8ac4898b89c98d977e2c6d8d93f25814fe91869087757785dfe",
    x1: 87.606,
    y1: 134.6,
    x2: 113.355,
    y2: 134.6,
    xlinkHref: "#SVGID_0_517d1a40c5c0a8ac4898b89c98d977e2c6d8d93f25814fe91869087757785dfe"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Vrstva_3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "MI_4L_main",
    d: "M87.823 84.342h69.807l-20.581-12.533-20.58-12.532-20.581 12.532-3.502 2.133M97.176 84.803v24.743M146.314 84.803v36.912h-10.663V84.803M121.896 121.715h34.727"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Vrstva_2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "MI_4L_gradient",
    d: "M89.93 111.62c-1.071-3.429-2.311-7.923-3.089-12.451-1.51-8.786 1.125-17.383 2.566-20.221 2.83-5.576 8.394-14.251 8.419-20.516.042-10.471-8.489-18.96-18.96-18.96l-1.298-.032c-10.471 0-19.002 8.489-18.96 18.96.025 6.265 5.588 14.941 8.419 20.516 2.117 4.171 3.818 13.695 2.704 20.381-1.201 7.206-6.562 18.377-6.562 18.377",
    stroke: "url(#SVGID_0_517d1a40c5c0a8ac4898b89c98d977e2c6d8d93f25814fe91869087757785dfe)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "MI_4L_main",
    stroke: "url(#SVGID_1_517d1a40c5c0a8ac4898b89c98d977e2c6d8d93f25814fe91869087757785dfe)",
    d: "M75.823 130.734H47.117v-12.916h34.816"
  }), /*#__PURE__*/React.createElement("path", {
    className: "MI_4L_main",
    stroke: "url(#SVGID_2_517d1a40c5c0a8ac4898b89c98d977e2c6d8d93f25814fe91869087757785dfe)",
    d: "M53.021 138.711h23.298"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "MI_4L_main",
    cx: 100.534,
    cy: 133.902,
    r: 24.457
  }), /*#__PURE__*/React.createElement("path", {
    className: "MI_4L_main",
    stroke: "url(#SVGID_3_517d1a40c5c0a8ac4898b89c98d977e2c6d8d93f25814fe91869087757785dfe)",
    d: "M88.856 134.372l8.206 9.117 15.043-17.778"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVatViesStatementReport);
export default __webpack_public_path__ + "static/media/vatViesStatementReport.8ce3d9adcdac1f6a987ea413815aef6a.svg";
export { ForwardRef as ReactComponent };